import { FormIcon } from './FormIcon.jsx';
import { STATUS_META, categoryLabel } from './formSchema.js';

export function StatusPill({ status, label }) {
  const meta = STATUS_META[status] || { label: status, tone: 'gray' };
  return (
    <span className={`fm-status fm-status--${meta.tone}`}>
      <span className="fm-status-dot" aria-hidden="true" />
      {label || meta.label}
    </span>
  );
}

export function TypePill({ category }) {
  return <span className={`fm-type fm-type--${category}`}>{categoryLabel(category)}</span>;
}

export function FormRowIcon({ category }) {
  return (
    <span className={`fm-row-icon fm-row-icon--${category}`} aria-hidden="true">
      <FormIcon name={category === 'template' ? 'template' : 'forms'} size={16} />
    </span>
  );
}

export function SubmissionStatusPill({ status }) {
  return <span className={`fm-sub-status fm-sub-status--${status}`}>{status === 'reviewed' ? 'Reviewed' : 'New'}</span>;
}
